import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, ViewEncapsulation } from '@angular/core';

import { ButtonComponent } from '../../atoms/button/button.component';

/** Contenido del banner. `aceptaOferta` decide a qué paso del flujo se entra. */
export interface ContenidoBannerProntoPago {
  chip: string;
  title: string;
  body: string;
  cta: string;
  aceptaOferta: boolean;
}

/**
 * Banner de oferta "Pago Anticipado Pronto Pago".
 */
@Component({
  selector: 'app-banner-pronto-pago',
  standalone: true,
  imports: [CommonModule, ButtonComponent],
  templateUrl: './banner-pronto-pago.component.html',
  styleUrl: './banner-pronto-pago.component.scss',
  encapsulation: ViewEncapsulation.None
})
export class BannerProntoPagoComponent {

  @Input() ContentBannerProntoPago: ContenidoBannerProntoPago = {
    chip: '',
    title: '',
    body: '',
    cta: '',
    aceptaOferta: false
  };

  /** `resultado` si el usuario ya aceptó la oferta; `propuesta` en caso contrario. */
  @Output() abrir = new EventEmitter<'propuesta' | 'resultado'>();

  abrirProntoPago(): void {
    this.abrir.emit(this.ContentBannerProntoPago.aceptaOferta ? 'resultado' : 'propuesta');
  }
}
